<template>
  <div class="result-list">
    <van-collapse v-model="activeNames">
      <van-collapse-item :title="item.title" :name="index" v-for="(item, index) of resultArray" :key="index">
        <div v-if="needShowResult" class="result-list-content">
          <p>测评得分：{{ item.total }}分</p>
          <p>测评结果：{{ item.result }}</p>
          <div v-if="item.measures != ''" class="result-list-content-check-container">
            <p>测评建议：</p>
            <p class="result-list-content-check-container-button" @click="onCheck(index)">
              点击查看
            </p>
          </div>
        </div>
        <p v-else>已完成</p>
      </van-collapse-item>
    </van-collapse>
    <div class="result-list-button-container">
      <button v-if="canReTest" class="result-list-button-container-button" @click="onReTestClick">
        重新填写
      </button>
      <button class="result-list-button-container-button" @click="onHomeClick">
        回到主页
      </button>
    </div>
    <div v-if="isShowAlert" class="alert">
      <div class="alert-content">
        <p class="alert-content-title">测评建议</p>
        <p class="alert-content-description" v-html="alertInfo" />
        <div class="alert-content-bottom">
          <div class="alert-content-bottom-gradient"></div>
          <div class="alert-content-bottom-button-container">
            <button class="alert-content-bottom-button-container-button" @click="onClose">
              关闭
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api';
import { NavigationTool } from '@/utils/navigation-tool.js'
export default {
  data() {
    return {
      activeNames: [],
      isFromQuery: false,
      resultIds: null,
      resultArray: [],
      isShowAlert: false,
      alertInfo: ''
    }
  },

  created() {
    this.isFromQuery = this.$router.history.current.query.isFromQuery
    this.resultIds = this.$router.history.current.query.resultIds

    // if (this.accountModel.result) {
    //   this.resultArray = this.accountModel.result 
    // } else {
    //   this.getResult(this.resultIds)
    // }
    this.getResult(this.resultIds)
  },

  computed: {
    canReTest() {
      return this.$store.state.configurationModel.canReTest
    },

    needShowResult() {
      return this.$store.state.configurationModel.needShowResult
    },

    uid() {
      return this.$store.getters['user/getUser']?.uid ?? null
    },

    accountModel() {
      return this.$store.state.accountModel
    },
  },

  methods: {
    // action
    onCheck(index) {
      this.isShowAlert = true
      this.alertInfo = this.resultArray[index].measures
    },

    onClose() {
      this.isShowAlert = false
    },

    onReTestClick() {
      this.resetFillStatus()
      NavigationTool.queryNavigate()
    },
    onHomeClick() {
      this.$router.push({ name: 'Home' })
    },

    // method
    async getResult(resultIds) {

      const [error, data] = await to(this.getResultRequest(resultIds))
      if (error) {
        this.$toast(error)
        return
      }
      // resultArray
      this.resultArray = data

      // activeNames
      for (let i = 0; i < this.resultArray.length; i++) {
        this.activeNames[i] = i
      }
    },

    resetFillStatus() {
      const newConfigurationModel = this.$store.state.configurationModel
      newConfigurationModel.assessmentArray.forEach((_, index) => {
        newConfigurationModel.assessmentArray[index].isFilled = false
      })
      this.$store.commit('saveConfigurationModel', newConfigurationModel)
    },

    // requst
    getResultRequest(resultIds) {
      return API.getResult({
        resultIds: resultIds ? resultIds.split(',') : null,
        userId: this.uid
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@use "@css/style.scss";

.result-list {
  background-color: #f9f9f9;
  width: 100%;
  height: 100%;

  &-content {
    display: flex;
    flex-direction: column;

    &-check-container {
      display: flex;

      &-button {
        color: #596afd;
      }
    }
  }

  &-button-container {
    background-color: white;
    width: 100%;
    height: 100px;
    position: fixed;
    bottom: 0px;
    display: flex;
    align-items: center;
    justify-content: center;

    &-button {
      background-color: #596afd;
      color: white;
      font-size: 16px;
      max-width: 343px;
      min-width: 150px;
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 22px;
      flex: 1;
      margin-right: 10px;
      &:last-child {
        margin-right: 0px;
      }
    }
  }
}

.alert {
  position: fixed;
  background-color: rgba(#000000, 0.5);
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  &-content {
    position: relative;
    background-color: #fff;
    border-radius: 16px;
    width: 311px;
    height: 360px;
    display: flex;
    flex-direction: column;
    align-items: center;

    &-title {
      color: #323233;
      font-size: 16px;
      font-weight: 500;
      text-align: center;
      line-height: 24px;
      padding-top: 24px;
      padding-bottom: 8px;
    }

    &-description {
      color: #323233;
      font-size: 14px;
      width: 100%;
      height: 244px;
      box-sizing: border-box;
      padding: 8px 14px;
      overflow: hidden;
      overflow-y: auto;
    }

    &-bottom {
      z-index: 1;
      position: absolute;
      width: 100%;
      bottom: 0;
      display: flex;
      flex-direction: column;

      &-gradient {
        background: linear-gradient(180deg, rgba(#ffffff, 0) 0%, #ffffff 100%);
        width: 100%;
        height: 48px;
      }

      &-button-container {
        width: 100%;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;

        &-button {
          color: white;
          background-color: #596afd;
          font-size: 14px;
          width: 263px;
          height: 36px;
          border-radius: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
}
</style>
